/* src/app/components/control-module/step/step.component.css */
.disabledbutton {
  pointer-events: none;
  opacity: 0.4;
}
.draft {
  color: var(--fg-3);
  font-weight: 630;
}
.ongoing {
  color: var(--navy-600);
  font-weight: 630;
}
.suspended {
  color: var(--navy-600);
  font-weight: 630;
}
.submitted {
  color: var(--warning);
  font-weight: 630;
}
.approved {
  color: var(--success);
  font-weight: 630;
}
.tabbable .nav-tabs {
  overflow-x: auto;
  overflow-y: hidden;
  flex-wrap: nowrap;
}
.tabbable .nav-tabs .nav-link {
  white-space: nowrap;
}
.table-div {
  display: table;
  overflow: hidden;
}
.table-cell {
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  padding: 6px;
  margin: 10px;
}
.deadline-task {
  font-size: 16px;
  color: white;
  background-color: var(--danger);
  border-radius: 5px;
}
/*# sourceMappingURL=step.component.css.map */
